export default __webpack_public_path__ + "static/jesus-ffe86870e632ffcac01ee466024b4481.png";